import { RootState } from "@/app/stores";
import { getPartnerTransaction } from "@/shared/api/partners";
import { IGetPartnerTransactionResult } from "@/shared/api/partners";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchPartnerTransaction = createAsyncThunk<
    IGetPartnerTransactionResult,
    string,
    { state: RootState }
>('partnerTransaction/fetchPartnerTransaction', async(id, thunkAPI) => {
    try {
        const data = await getPartnerTransaction(id)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})